import { render, staticRenderFns } from "./StockOrder.vue?vue&type=template&id=1719f057"
import script from "./StockOrder.vue?vue&type=script&lang=js"
export * from "./StockOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports